import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {settingsPublicProfile} from "store/reducer/user/settings/selectors";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import {Switch} from "features/components/switch";
import {setProfileSettingsStart} from "store/reducer/user/settings/reducer";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: settingsPublicProfile(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    setProfileSettingsStart
};

export const PublicProfileSettings = (props) => {
    const {data, setProfileSettingsStart} = props;

    const onChange = useCallback((key, status) => {
        setProfileSettingsStart({key, value: status});
    }, [setProfileSettingsStart]);

    const switch_disabled = ["show_basic_info", "show_desc_languages"];

    return <div className="white-box public-profile-settings">
        <Title size={20} align={"center"}>{__("public-profile-settings.title")}</Title>
        <Text size={16} align={"center"}>{__("public-profile-settings.text")}</Text>
        {data.map(i => <Switch key={i.key} title={__(`public-profile-settings.${i.key}`)} status={i.value} disabled={switch_disabled.includes(i.key) && !!i.value}  onChange={(val) => onChange(i.key, val)}/>)}
    </div>
}
export default connect(mapStateToProps, mapDispatchToProps)(PublicProfileSettings);
